import BarChart from './barchart'
import DoughnutChart from './doughnutchart'
import HorizontalBarChart  from './horizontalbarchart'
import LineChart from './linechart'

export const barChart = BarChart;

export const doughnutChart = DoughnutChart;

export const horizontalBarChart = HorizontalBarChart;

export const lineChart = LineChart;
